import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  inventoryItem: null,
  allStoresItems: [],
  singleStoreItems: [],
  lowStockItems: [],
  outOfStockItems: [],
  inventoryStats: null,
  inventoryValue: 0,
  success: false,
  error: null,
  message: null,
  pendingTransfers: [],
  // Reconciled Item state
  reconciledItems: [],
  reconciledItem: null,
};

export const storeInventoryReducer = createReducer(initialState, (builder) => {
  builder
    // Create Inventory Item
    .addCase('createInventoryItemRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('createInventoryItemSuccess', (state, action) => {
      state.isLoading = false;
      state.inventoryItem = action.payload;
      state.success = true;
    })
    .addCase('createInventoryItemFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Fetch All Stores Items
    .addCase('getAllStoresItemsRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getAllStoresItemsSuccess', (state, action) => {
      state.isLoading = false;
      state.allStoresItems = action.payload;
    })
    .addCase('getAllStoresItemsFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    // Fetch Single Store Items
    .addCase('getSingleStoreItemsRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getSingleStoreItemsSuccess', (state, action) => {
      state.isLoading = false;
      state.singleStoreItems = action.payload;
    })
    .addCase('getSingleStoreItemsFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    // Edit Store Inventory Item
    .addCase('editStoreInventoryItemRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('editStoreInventoryItemSuccess', (state, action) => {
      state.isLoading = false;
      state.inventoryItem = action.payload;
      state.success = true;
    })
    .addCase('editStoreInventoryItemFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Add Inventory Quantity to an Item
    .addCase('addInventoryQuantityRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('addInventoryQuantitySuccess', (state, action) => {
      state.isLoading = false;
      state.inventoryItem = action.payload;
      state.success = true;
    })
    .addCase('addInventoryQuantityFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Remove Inventory Quantity from an Item
    .addCase('removeInventoryQuantityRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('removeInventoryQuantitySuccess', (state, action) => {
      state.isLoading = false;
      state.inventoryItem = action.payload;
      state.success = true;
    })
    .addCase('removeInventoryQuantityFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Deduct Inventory Quantity from an Item
    .addCase('deductInventoryQuantityRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('deductInventoryQuantitySuccess', (state, action) => {
      state.isLoading = false;
      state.inventoryItem = action.payload;
      state.success = true;
    })
    .addCase('deductInventoryQuantityFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Transfer Inventory Item
    .addCase('transferInventoryItemRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('transferInventoryItemSuccess', (state, action) => {
      state.isLoading = false;
      state.inventoryItem = action.payload;
      state.success = true;
    })
    .addCase('transferInventoryItemFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Receive Inventory Transfer
    .addCase('receiveInventoryTransferRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('receiveInventoryTransferSuccess', (state, action) => {
      state.isLoading = false;
      state.message = action.payload;
      state.success = true;
    })
    .addCase('receiveInventoryTransferFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Get Pending Transfers
    .addCase('getPendingTransfersRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getPendingTransfersSuccess', (state, action) => {
      state.isLoading = false;
      state.pendingTransfers = action.payload;
    })
    .addCase('getPendingTransfersFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    // Get Inventory Item Details
    .addCase('getInventoryItemDetailsRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getInventoryItemDetailsSuccess', (state, action) => {
      state.isLoading = false;
      state.inventoryItem = action.payload;
    })
    .addCase('getInventoryItemDetailsFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    // Activate or Deactivate Store Inventory Item
    .addCase('toggleInventoryItemStatusRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('toggleInventoryItemStatusSuccess', (state, action) => {
      state.isLoading = false;
      state.inventoryItem = action.payload;
      state.success = true;
    })
    .addCase('toggleInventoryItemStatusFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Delete Inventory Item
    .addCase('deleteInventoryItemRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('deleteInventoryItemSuccess', (state, action) => {
      state.isLoading = false;
      state.message = action.payload;
    })
    .addCase('deleteInventoryItemFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    // Delete Inventory Activity
    .addCase('deleteInventoryActivityRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('deleteInventoryActivitySuccess', (state, action) => {
      state.isLoading = false;
      state.inventoryItem = action.payload;
      state.success = true;
    })
    .addCase('deleteInventoryActivityFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Approve Inventory Activity
    .addCase('approveInventoryActivityRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('approveInventoryActivitySuccess', (state, action) => {
      state.isLoading = false;
      state.inventoryItem = action.payload;
      state.success = true;
    })
    .addCase('approveInventoryActivityFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Get store inventory value
    .addCase('getInventoryValueRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getInventoryValueSuccess', (state, action) => {
      state.isLoading = false;
      state.inventoryValue = action.payload;
    })
    .addCase('getInventoryValueFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    // Clear Errors
    .addCase('clearErrors', (state) => {
      state.error = null;
    })

    // Clear Success Messages
    .addCase('clearSuccess', (state) => {
      state.message = null;
      state.success = false;
    })

    // Clear All Stores Items
    .addCase('clearAllStoresItems', (state) => {
      state.allStoresItems = [];
    })

    // Clear Single Store Items
    .addCase('clearSingleStoreItems', (state) => {
      state.singleStoreItems = [];
    })

    // Reconciled Item cases
    // Get All Reconciled Items
    .addCase('getAllReconciledItemsRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getAllReconciledItemsSuccess', (state, action) => {
      state.isLoading = false;
      state.reconciledItems = action.payload;
      state.success = true;
    })
    .addCase('getAllReconciledItemsFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Get Single Reconciled Item
    .addCase('getSingleReconciledItemRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getSingleReconciledItemSuccess', (state, action) => {
      state.isLoading = false;
      state.reconciledItem = action.payload;
      state.success = true;
    })
    .addCase('getSingleReconciledItemFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Get Reconciled Items by Organization
    .addCase('getReconciledItemsByOrganizationRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getReconciledItemsByOrganizationSuccess', (state, action) => {
      state.isLoading = false;
      state.reconciledItems = action.payload;
      state.success = true;
    })
    .addCase('getReconciledItemsByOrganizationFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })
    // Get Reconciled Items by Store
    .addCase('getReconciledItemsByStoreRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getReconciledItemsByStoreSuccess', (state, action) => {
      state.isLoading = false;
      state.reconciledItems = action.payload;
      state.success = true;
    })
    .addCase('getReconciledItemsByStoreFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Create Reconciled Item
    .addCase('createReconciledItemRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('createReconciledItemSuccess', (state, action) => {
      state.isLoading = false;
      state.reconciledItem = action.payload;
      state.success = true;
    })
    .addCase('createReconciledItemFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Update Reconciled Item
    .addCase('updateReconciledItemRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('updateReconciledItemSuccess', (state, action) => {
      state.isLoading = false;
      state.reconciledItem = action.payload;
      const index = state.reconciledItems.findIndex(r => r._id === action.payload._id);
      if (index !== -1) {
        state.reconciledItems[index] = action.payload;
      }
      state.success = true;
    })
    .addCase('updateReconciledItemFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Approve Reconciled Item
    .addCase('approveReconciledItemRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('approveReconciledItemSuccess', (state, action) => {
      state.isLoading = false;
      state.reconciledItem = action.payload;
      const index = state.reconciledItems.findIndex(r => r._id === action.payload._id);
      if (index !== -1) {
        state.reconciledItems[index] = action.payload;
      }
      state.success = true;
    })
    .addCase('approveReconciledItemFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Cancel Reconciled Item
    .addCase('cancelReconciledItemRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('cancelReconciledItemSuccess', (state, action) => {
      state.isLoading = false;
      state.reconciledItem = action.payload;
      const index = state.reconciledItems.findIndex(r => r._id === action.payload._id);
      if (index !== -1) {
        state.reconciledItems[index] = action.payload;
      }
      state.success = true;
    })
    .addCase('cancelReconciledItemFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Delete Reconciliation
    .addCase('deleteReconciliationRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('deleteReconciliationSuccess', (state) => {
      state.isLoading = false;
      // Since there's only one reconciliation, just remove it
      state.reconciliation = null;
      state.success = true;
    })
    .addCase('deleteReconciliationFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Update Default Selling Unit
    .addCase('updateDefaultSellingUnitRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('updateDefaultSellingUnitSuccess', (state, action) => {
      state.isLoading = false;
      state.inventoryItem = action.payload;
      state.success = true;
    })
    .addCase('updateDefaultSellingUnitFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    });
});
